/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { DisciplineClassItemViewModel } from "../types/DisciplineClassItemViewModel.ts";

export const disciplineClassItemViewModelSchema = z.object({
  id: z.optional(z.number().int()),
  startDate: z.optional(z.string().datetime()),
  endDate: z.optional(z.string().datetime()),
}) as unknown as ToZod<DisciplineClassItemViewModel>;
